module.exports = "/images/7d62a61cb56d30863040cc1b0270c890.svg";